
class CheckoutClick extends HTMLElement {
  constructor() {
    super();


    this.querySelector("[name='checkout']")?.addEventListener('click', (event) => {
      event.preventDefault();
      console.log("event",event.targetm,!event.target.hasAttribute('data-customer-tag'));
    //   if (!event.target.hasAttribute('data-customer-tag')){
    //       window.location.href = '/checkout'; 
    //       return;
    //   } 
      this.apply();
    });
  }

 async apply() {
     try {
      this.classList.add('loadding');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');
      const cart_object = await get_cart();
      const cart_items = cart_object.items || [];
      const cart_currencyCode = cart_object.currency || "EUR";
      const cart_attribute = cart_object.attributes;
      console.log("cart_currencyCode",cart_object)

      const cart_items_object = buildCustomLineItems(cart_items, cart_currencyCode,cart_attribute);
      Draft_Order(cart_items_object,this);
    } catch (error) {
      console.error("Checkout processing failed:", error);
    }
    
  }
}

customElements.define('checkout-click', CheckoutClick);

async function get_cart() {
  try {
    const response = await fetch(`${routes.cart_url}.json`);
    if (!response.ok) throw new Error("Failed to fetch cart");
    const data = await response.json();
    return data;
  } catch (e) {
    console.error("Error fetching cart:", e);
    throw e;
  }
}

function buildCustomLineItems(cartItems, currencyCode, cartAttributes = {}) {
  const shippingAttrValue = cartAttributes['in_germany']; 
  
  console.log("shippingAttrValue",shippingAttrValue)

  const lineItems = cartItems
    .filter(item => {
      if (
        shippingAttrValue == "false" &&
        (item.id === main_draf_vid || item.variant_id === main_draf_vid)
      ) {
        return false;
      }
      return true;
    })
        .map(item => ({
      variantId: item.variant_id,
      quantity: item.quantity,
      sku: item.sku,
        amount: (
          parseFloat(item.price || 0) +
          (item.properties['_data-custom-price']
            ? parseFloat(window.monogram_product_json?.[0]?.price || 0)
            : 0)) / 100,
      currency_code: currencyCode,
      customAttributes: item.properties
        ? Object.entries(item.properties).map(([key, value]) => ({
            key,
             value: key === "monogram" && value === "With Monogram" ? `${String(value)} (${window.monogram_product_price})`: String(value)
          }))
        : []
    }));
    // .map(item => ({
    //   variantId: item.variant_id,
    //   quantity: item.quantity, 
    //   sku: item.sku,
    //     amount: (
    //     parseFloat(item.price || 0) +
    //     parseFloat(item.properties['_data-custom-price'] || 0)
    //     ) / 100,
    //   currency_code: currencyCode,
    //   customAttributes: item.properties
    //     ? Object.entries(item.properties).map(([key, value]) => ({
    //         key,
    //         value: String(value)
    //       }))
    //     : []
    // }));

  return {
    lineItems,
    currency_code:currencyCode,
    country_code:Shopify.country,
    customAttributes: [] // You can include order-level attributes if needed
  };
}




function Draft_Order(cart_Json,This) {
const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
const raw =JSON.stringify(cart_Json);
  console.log(raw);
const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch("https://kow.dfm.temporary.site/website_e5e4703e/Draftorder/draft_order.php", requestOptions)
  .then((response) => response.json())
      .then((result) => {
          console.log(result);
          This.classList.remove('loadding');
           This.querySelector('.loading__spinner')?.classList.add('hidden');
        window.location.href = result.data.draftOrderCreate.draftOrder.invoiceUrl    
  })
  .catch((error) => console.error(error));
}